import axios from '@axios'

export default {
  fetchCharts() {
    return axios.get('/charts')
  },
  fetchEditions(slug, year = null) {
    return axios.get(`/charts/${slug}/editions`, { params: year ? { year } : {} })
  },
  fetchEdition(slug, date = null) {
    return axios.get(date ? `/charts/${slug}/edition/${date}` : `/charts/${slug}/edition`)
  },
  fetchSong(id) {
    return axios.get(`/charts/songs/${id}`)
  },
  linkSong(id, payload) {
    return axios.patch(`/charts/songs/${id}/link`, payload)
  },
  fetchTrackCharts(trackId) {
    return axios.get(`/charts/track/${trackId}`)
  },
  fetchArtistCharts(artistId) {
    return axios.get(`/charts/artist/${artistId}`)
  },
  searchTracks(q) {
    return axios.get('/track', { params: { q, per_page: 20 } })
  },
  searchArtists(q) {
    return axios.get('/artist', { params: { q, per_page: 20 } })
  },
}
